import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateTeacherFavoriteStudio = createApiThunk<void, { id: string }>(
  "teachers/updateTeacherFavoriteStudio",
  async (favoriteStudio: { id: string }, { extra: { teacherRepository } }) => {
    await teacherRepository!.updateFavoriteStudio(favoriteStudio);
  },
);

export const resetUpdateTeacherFavoriteStudio = createAction("teachers/resetUpdateTeacherFavoriteStudio");
